module.exports = __webpack_public_path__ + "img/img_google_play.36d9ff1d.png";